import React from 'react';
import { Square, SquareCheck } from "lucide-react";

const SitesList = ({ 
  systems, 
  selectedSystemIds, 
  onSystemClick, 
  onCheckboxChange, 
  onFitToSelected 
}) => {
  if (systems.length === 0) {
    return (
      <div className="text-center py-8 text-gray-400">
        <p className="text-sm">No sites found</p>
      </div>
    );
  }

  return (
    <>
      {systems.map((system) => {
        const isSelected = selectedSystemIds.has(system.system_id);
        return (
          <div
            key={system.composite_key}
            onClick={() => onSystemClick(system)}
            className="p-3 rounded-lg border cursor-pointer transition-all hover:bg-gray-50"
          >
            <div className="flex items-start justify-between">
              <div className="flex-1">
                <div className="flex items-center space-x-2">
                  <h4 className="font-medium text-sm text-gray-900">
                    {system.system_street}
                  </h4>
                  <div className="mr-3 mt-0.5">
                    <button
                      onClick={(e) => {
                        e.stopPropagation();
                        onCheckboxChange(system.system_id, !isSelected);
                      }}
                      className="text-blue-600 hover:text-blue-800"
                    >
                      {isSelected ? (
                        <SquareCheck className="w-5 h-5" />
                      ) : (
                        <Square className="w-5 h-5" />
                      )}
                    </button>
                  </div>
                </div>
                <p className="text-xs text-gray-500 mt-1">
                  {system.street_name}
                </p>
                <p className="text-xs text-gray-500 mt-1">
                  {system.system_timezone}
                </p>
              </div>
            </div>
          </div>
        );
      })}
      {selectedSystemIds.size > 0 && (
        <div>
          <button
            onClick={onFitToSelected}
            className="text-xs px-2 py-1 bg-blue-500 text-white rounded hover:bg-blue-600"
          >
            Fit to Selected ({selectedSystemIds.size})
          </button>
        </div>
      )}
    </>
  );
};

export default SitesList;
